// import React from "react";
import SecurityOneCheckInByCode from "../securityOneComponent/SecurityOneCheckInByCode";
import SecurityOneCheckInWithoutCode from "../securityOneComponent/SecurityOneCheckInWithoutCode";

const Visitors = () => {
  return (
    <div>
      <SecurityOneCheckInByCode />
      <hr />
      <SecurityOneCheckInWithoutCode />
      <br />
    </div>
  );
};

export default Visitors;
